import { type DomainEntity } from "./entity";
import type { TermsAndConditionsResponse } from "types/schemas";

export type LegalPageKey = "privacy-policy-and-data-transparency" | "instructions-for-use" | "terms-and-conditions";

export type LegalPage = {
  key: LegalPageKey;
  date: Date;
  version: string;
  preContent: string | undefined;
  content: string;
  title: string;
  subtitle: string;
  pdfUrl: string | undefined;
}

export type LanguageKey = "en" | "de" | "fr" | "it";

export const mapLocaleToLanguage = (locale: string): LanguageKey => {
  switch (locale) {
    case "en-CH":
      return "en";
    case "de":
      return "de";
    case "fr":
      return "fr";
    case "it":
      return "it";
    default:
      return "de";
  }
};

export type TermsAndConditionsDTO = {
  terms_and_conditions_accepted: boolean;
  data_privacy_policy_accepted: boolean;
  terms_and_conditions_accepted_timestamp: string | null;
  data_privacy_policy_accepted_timestamp: string | null;
  terms_version: string | null;
  privacy_policy_version: string | null;
}

export type TermsAndConditions = {
  termsAndConditionsAccepted: boolean;
  dataPrivacyPolicyAccepted: boolean;
  termsAndConditionsAcceptedTimestamp: string | null;
  dataPrivacyPolicyAcceptedTimestamp: string | null;
  termsVersion: string | null;
  privacyPolicyVersion: string | null;
} & DomainEntity


export const hasAcceptedCurrentLegalVersion = (
  termsAndConditionsLegalPage: LegalPage | undefined,
  privacyPolicyLegalPage: LegalPage | undefined,
  therapistTerms: TermsAndConditionsResponse | undefined,
): { termsAndConditionsAccepted: boolean; privacyPolicyAccepted: boolean } => {
  const currentTermsAndConditionsVersion = termsAndConditionsLegalPage?.version;
  const currentPrivacyPolicyVersion = privacyPolicyLegalPage?.version;
  const privacyPolicyVersion = therapistTerms?.privacyPolicyVersion;
  const termsVersion = therapistTerms?.termsVersion;

  return {
    privacyPolicyAccepted: currentPrivacyPolicyVersion === privacyPolicyVersion,
    termsAndConditionsAccepted: termsVersion === currentTermsAndConditionsVersion,
  };
};
